module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-screen.029eaf63.png";